import { Link, Stack, Typography, useTheme } from "@mui/material";

interface Props {
  email?: string;
  phone?: string;
  isMobile?: boolean;
}

const ensureLeadingPlusSign = (phone: string): string => (phone.startsWith("+") ? phone : `+${phone}`);

const SupportInfo = ({ email, phone, isMobile }: Props) => {
  const theme = useTheme();

  const phoneNumber = phone ? ensureLeadingPlusSign(phone) : undefined;

  return (
    <Stack spacing={2}>
      <Typography variant="subtitle1">Contact Support Center</Typography>
      {email && (
        <Stack>
          <Typography color="textSecondary">Email</Typography>
          <Link style={{ color: theme.palette.primary.main }} href={`mailto:${email}`}>
            {email}
          </Link>
        </Stack>
      )}
      {phone && (
        <Stack>
          <Typography color="textSecondary">Phone</Typography>
          {isMobile ? (
            <Link style={{ color: theme.palette.primary.main }} href={`tel:${phoneNumber}`}>
              {phoneNumber}
            </Link>
          ) : (
            <Typography>{phoneNumber}</Typography>
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default SupportInfo;
